// BrandingProvider — Phase 13 Commit 8 + 11.
//
// Wraps the Public-Viewer subtree in a <div> that carries every
// BrandingTokens V2 value as a CSS custom property. Downstream
// Viewer-Chrome components read the brand via `var(--scrolly-brand-*)`
// (CSS) or via the `useBrandingTokens()` hook (in ./branding-context.ts —
// split out so this file stays react-refresh-clean).
//
// Rendered at SSR time (no useEffect): the style-attribute and the
// Context value are available on first paint, no hydration flicker.

import type { ReactNode } from "react";
import { tokensToCssVars, type BrandingTokens } from "@scrolly/branding";
import { BrandingContext } from "./branding-context";

interface BrandingProviderProps {
  tokens: BrandingTokens;
  children: ReactNode;
}

export function BrandingProvider({ tokens, children }: BrandingProviderProps) {
  const cssVars = tokensToCssVars(tokens);
  // React's CSSProperties type does not know about custom properties, so
  // the cast is the normal React idiom for CSS-var emission. We pick
  // `min-height: 100vh` here to keep the wrapper covering the whole
  // viewport — the viewer itself is fullscreen, and we want the brand
  // background available even on short content.
  return (
    <BrandingContext.Provider value={tokens}>
      <div
        data-scrolly-branding="v2"
        style={{
          ...(cssVars as React.CSSProperties),
          minHeight: "100vh",
        }}
      >
        {children}
      </div>
    </BrandingContext.Provider>
  );
}
